import { createFileRoute } from "@tanstack/react-router";
import { DonationPageEditor } from "@/components/fundraising/DonationPageEditor";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/fundraising/page-builder")({
	component: PageBuilderPage,
});

function PageBuilderPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="p-6 text-muted-foreground">No campaign selected.</div>
		);
	}

	return (
		<div className="p-6">
			<DonationPageEditor campaignId={campaignId} />
		</div>
	);
}
